import { render, staticRenderFns } from "./shouru.vue?vue&type=template&id=b1b07bc8&scoped=true&"
import script from "./shouru.vue?vue&type=script&lang=js&"
export * from "./shouru.vue?vue&type=script&lang=js&"
import style0 from "./shouru.vue?vue&type=style&index=0&id=b1b07bc8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b07bc8",
  null
  
)

export default component.exports